import React from 'react';
import Img from 'gatsby-image';
import { string, shape } from 'prop-types';
import PageTitle from './PageTitle';
import LocalizedLink from './LocalizedLink';
import FadeInSection from './FadeInSection';

const AboutHome = ({ headline, text, image, cta, className }) => {
  return (
    <div className={className}>
      <div className="flex flex-col lg:flex-row lg:justify-center lg:items-center lg:ml-16">
        <div className="flex justify-end w-full h-full lg:justify-start lg:w-1/3">
          {image && <Img fluid={image.fluid} alt={image.alt} className="w-4/5 lg:w-full" />}
        </div>
        <FadeInSection className="w-11/12 relative bottom-8 lg:bottom-0  lg:w-1/2 lg:right-16">
          <div
            style={{ backgroundColor: 'rgba(247, 228, 212, 0.9)' }}
            className="flex flex-col items-center justify-center bg-light-100 py-8 px-4 lg:py-8"
          >
            <PageTitle className="mb-8" title={headline} />
            <div className="mb-8">{text}</div>
            <LocalizedLink
              className="py-4 bg-white text-lg text-light-700 text-center font-bold shadow-xl rounded uppercase no-underline w-full lg:w-1/2 lg:py-6"
              to={cta.link}
            >
              {cta.label}
            </LocalizedLink>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
};

AboutHome.propTypes = {
  headline: string,
  text: string,
  image: shape({}),
  cta: shape({
    link: string,
    label: string,
  }),
  className: string,
};

AboutHome.defaultProps = {
  headline: null,
  text: null,
  image: null,
  cta: null,
  className: null,
};

export default AboutHome;
